import { render } from "./OrderPromotionDetail.vue?vue&type=template&id=787fe189&scoped=true"
import script from "./OrderPromotionDetail.vue?vue&type=script&lang=js"
export * from "./OrderPromotionDetail.vue?vue&type=script&lang=js"

import "./OrderPromotionDetail.vue?vue&type=style&index=0&id=787fe189&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-787fe189"]])

export default __exports__